import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import HomePage from '../views/HomePage.vue';
import SmartSearchPage from "@/views/SmartSearchPage.vue"
import SmartCard from "@/views/SmartCard.vue"
import SmartPlanner from "@/views/SmartPlanner.vue";
import BlogSearch from "@/components/blogSearch.vue";
import StandardPage from "@/components/standardPage.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        component: HomePage,
    },
    {
        path: '/search/smart-cards',
        component: SmartSearchPage,
    },
    {
        path: '/search/business-listing',
        component: SmartSearchPage,
    },
    {
        path: '/smartcard/:id',
        component: SmartCard,
    },
    {
        path: '/smart-planner',
        component: SmartPlanner
    },
    {
        path: '/blog',
        component: BlogSearch
    },
    {
        path: '/directory',
        component: StandardPage
    },
    {
        path: '/packages/link1',
        component: StandardPage
    },
    {
        path: '/packages/link1/sublink1',
        component: StandardPage
    },
    {
        path: '/packages/link1/sublink2',
        component: StandardPage
    },
    {
        path: '/packages/link1/sublink3',
        component: StandardPage
    },
    {
        path: '/packages/link1/sublink4',
        component: StandardPage
    },
    {
        path: '/packages/link2',
        component: StandardPage
    },
    {
        path: '/packages/link3',
        component: StandardPage
    },
    {
        path: '/about',
        component: StandardPage
    },
    {
        path: '/itenary',
        component: StandardPage
    },
    {
        path: '/page',
        component: StandardPage
    },
    {
        path: '/page/',
        component: StandardPage
    },
    {
        path: '/page/:link',
        component: StandardPage
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'
})

export default router
